import { useMemo } from "react";

const useWorkerStressTest = () => {
  const worker = useMemo(() => new Worker(new URL("worker.js", import.meta.url), { type: "module" }), []);

  function ativar () {
    worker.postMessage({ getStressTest: true })

    worker.onmessage = function (event) {
    };
  }

  return {
    ativar
  }
}

export default useWorkerStressTest